'use client';

import React from 'react';
import { CheckedIcon } from '@/shared/ui/atoms/Icons';

export interface CheckBoxProps {
  id?: string;
  width?: number;
  height?: number;
  checked: boolean;
  checkedColor: string;
  uncheckedBgColor?: string;
  border: {
    color: string;
    borderWidth: string;
    radius: string;
  };
  showCheckWhenUnchecked?: boolean;
  checkedIconWidth?: number;
  checkedIconHeight?: number;
  checkedIconColor?: string;
  onChange: (checked: boolean) => void;
}

const CheckBox = ({
  id,
  width = 20,
  height = 20,
  checked,
  checkedColor,
  uncheckedBgColor = '#E5E7EB',
  border,
  showCheckWhenUnchecked = true,
  checkedIconWidth = 12,
  checkedIconHeight = 12,
  checkedIconColor = 'white',
  onChange
}: CheckBoxProps) => {
  const bgColor = checked ? checkedColor : uncheckedBgColor;
  const borderColor = checked ? checkedColor : border.color;

  return (
    <span
      className="relative inline-flex items-center justify-center cursor-pointer select-none"
      style={{
        width,
        height
      }}
      onClick={() => onChange(!checked)}
      role="checkbox"
      aria-checked={checked}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onChange(!checked);
        }
      }}
    >
      <input id={id} type="checkbox" className="sr-only" checked={checked} onChange={(e) => onChange(e.target.checked)} />
      <span
        className="absolute inset-0"
        style={{
          borderColor,
          borderWidth: border.borderWidth,
          borderRadius: border.radius,
          backgroundColor: bgColor
        }}
      />
      <span className="relative z-[1]">{(showCheckWhenUnchecked || checked) && <CheckedIcon width={checkedIconWidth} height={checkedIconHeight} color={checkedIconColor} />}</span>
    </span>
  );
};

export default CheckBox;
